import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import React, { useRef, useEffect, useCallback } from 'react';
import { getToken, getDataSession } from "views/Utils/Common";
import { fetchConToken } from 'helpers/fetch';
import { currency } from 'resources/utilities';
import { descargarFactura } from 'actions/archivos';
import Swal from 'sweetalert2';
import edit from 'images/panel/Icons/edit.svg'
import crearventa from 'images/panel/Icons/Convert.svg'
import cancelar from 'images/panel/Icons/Cancel.svg'
import pdf from 'images/panel/Icons/PDF.svg'
import coin from 'images/panel/Icons/Coin.svg'
import facturar from 'images/panel/Icons/New.svg'
import xml from 'images/panel/Icons/XML.svg'

const $ = require('jquery')
$.DataTable = require('datatables.net-select')
const baseUrl = process.env.REACT_APP_API_URL;
var detailRows = [];

const Table = (props) => {
     const tableRef = useRef();
     const tableRefInstance = useRef(null);
     const rellenarTable = useCallback(() => {
          if ($.fn.dataTable.isDataTable(tableRef.current))  $(tableRef.current).DataTable().destroy();
          
          var ArrayData = [];
          props.rows.forEach((i) => {
               switch (i[0]) {
                    case "desplegable":
                         ArrayData.push({
                              class: 'details-control',
                              orderable: false,
                              data: function (data, type, row, meta) {
                                   if (data['tiene_Variante'] === 'S') return '<spam  data-id="' + data[i[1]] + '" style="display:none"></spam>';
                                   else return '<spam class="varianteClass" data-id="' + data[i[1]] + '" style="display:none"></spam>';
                              },
                         });
                         break;
                    case "pdf":
                         ArrayData.push({
                              "class": "td-button text-center",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return '<button class="btn-descargar btn" type="button" data-id="' + data[i[1]] + '"  data-ruta="' + props.ruta + '/DescargarPDF" data-nombre="' + data['folio'] + '.pdf" ><img src="' + pdf + '" title="Descargar PDF" /></button>';
                              }
                         });
                         break;
                    case "xml":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return '<button class="btn btn-descargar" type="button" data-id="' + data[i[1]] + '"  data-ruta="Facturacion/DescargarXML" data-nombre="' + data['folio'] + '.xml" ><img src="' + xml + '" title="Descargar XML" /></button>';
                              }
                         });
                         break;
                    case "edit":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return '<a class="btn" href="' + props.path + "/edit/" + data[i[1]] + '"><img src="' + edit + '" title="Editar" /></a>';
                              }
                         });
                         break;
                    case "cancelar":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   if (data.estatus !== "CANCELADA")
                                        return '<button class="btn td-crearventa" type="button" data-evento="cancelar el documento" data-ruta="' + props.ruta + '/Cancelar?documento_id=' + data[i[1]] + '&sucursal_id=' + props.sucursal_id + '" ><img src="' + cancelar + '" title="Cancelar" /></button>';
                                   else return '';
                              }
                         });
                         break;
                    case "CrearVenta":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0)
                                        return "";
                                   // console.log(data)
                                   // console.log(data.folio_Venta)
                                   if (data.estatus !== "CANCELADA" && data.folio_Venta === null)
                                        return '<button class="btn td-crearventa" type="button" data-evento="crear venta de esta cotizacion" data-ruta="' + props.ruta + '/Terminar?documento_id=' + data[i[1]] + '&sucursal_id=' + props.sucursal_id + '" ><img src="' + crearventa + '"  title="Convertir a venta" /></button>';
                                   else return '';
                              }
                         });
                         break;
                    case "terminar":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0)
                                        return "";
                                   console.log(data)
                                   console.log(data.folio_Venta)
                                   if (data.estatus !== "CANCELADA" && data.estatus !== "TERMINADA" && data.folio_Venta === null)
                                        return '<button class="btn td-crearventa" type="button" data-evento="terminar la venta" data-ruta="' + props.ruta + '/Terminar?documento_id=' + data[i[1]] + '&sucursal_id=' + props.sucursal_id + '" ><img src="' + crearventa + '"  title="terminar la venta" /></button>';
                                   else return '';
                              }
                         });
                         break;
                    case "urlExtra":
                         ArrayData.push({
                              "class": "text-center",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return '<a class="btn" href="' + props.pathExtra + data[i[1]] + '"><img src="' + edit + '" title="Editar" /></a>';
                              }
                         });
                         break;
                    case "opciones":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   var dropdown = '<div class="btn-group" role="group">' +
                                        '<div class="btn-group" role="group">' +
                                        '  <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">' +
                                        '    Opciones' +
                                        '  </button>' +
                                        '  <ul class="dropdown-menu">';
                                   const opciones = props.opciones.split(",");
                                   for (i = 0; i < opciones.length; i++) {
                                        switch (opciones[i]) {
                                             case 'actualizar':
                                                  if (data.no_Orden !== data.folio) dropdown += '<li><button class="btn td-actualizarventa" data-orden="' + data.no_Orden + '"  type="button" ><img src="' + edit + '"/>&nbsp;Actualizar</button></li>';

                                                  break;
                                             case 'eliminar':
                                                  dropdown += '<li><button class="btn td-crearventa"  type="button" data-evento="eliminar esta conexión" data-ruta="' + props.path + "/Eliminar?id=" + data["id"] + '"><img src="' + edit + '"/>&nbsp;eliminar</button></li>';
                                                  break;
                                             case 'edit':
                                                  if (data.estatus !== "CANCELADA" && data.estatus !== "TERMINADA" && data.estatus !== "FACTURADA")
                                                       dropdown += '<li><a class="btn" href="' + props.path + "/edit/" + data["id"] + '"><img src="' + edit + '"/>&nbsp;Editar</a></li>';

                                                  break;
                                             case 'viewPdf':
                                                  dropdown += '<li><button class="btn-visualizar btn" type="button" data-id="' + data["id"] + '"  data-ruta="' + props.ruta + '/DescargarPDF" data-nombre="' + data['folio'] + '.pdf" ><img src="' + pdf + '" />&nbsp;Ver factura</button></li>';
                                                  break;
                                             case 'pdf':
                                                  dropdown += '<li><button class="btn-descargar btn" type="button" data-id="' + data["id"] + '"  data-ruta="' + props.ruta + '/DescargarPDF" data-nombre="' + data['folio'] + '.pdf" ><img src="' + pdf + '" />&nbsp;Descargar PDF</button></li>';
                                                  break;
                                             case 'xml':
                                                  dropdown += '<li><button class="btn btn-descargar" type="button" data-id="' + data["id"] + '"  data-ruta="Facturacion/DescargarXML" data-nombre="' + data['folio'] + '.xml" ><img src="' + xml + '" />&nbsp;Descargar XML</button></li>';
                                                  break;
                                             case 'cancelar':
                                                  if (data.estatus !== "CANCELADA" && data.estatus !== "TERMINADA" && data.estatus !== "FACTURADA")
                                                       dropdown += '<li><button class="btn td-crearventa" type="button" data-evento="cancelar el documento" data-ruta="' + props.ruta + '/Cancelar?documento_id=' + data["id"] + '&sucursal_id=' + props.sucursal_id + '" ><img src="' + cancelar + '" />&nbsp;Cancelar</button></li>';

                                                  break;
                                             case 'CrearVenta':
                                                  if (data.estatus !== "CANCELADA" && data.folio_Venta === null)
                                                       dropdown += '<li><button class="btn td-crearventa" type="button" data-evento="crear venta de esta cotizacion" data-ruta="' + props.ruta + '/Terminar?documento_id=' + data["id"] + '&sucursal_id=' + props.sucursal_id + '" ><img src="' + crearventa + '"  />&nbsp;Convertir a venta</button></li>';

                                                  break;
                                             case 'terminar':
                                                  if (data.estatus !== "CANCELADA" && data.estatus !== "TERMINADA" && data.folio_Venta === null && data.estatus !== "FACTURADA")
                                                       dropdown += '<li><button class="btn td-crearventa" type="button" data-evento="terminar la venta" data-ruta="' + props.ruta + '/Terminar?documento_id=' + data["id"] + '&sucursal_id=' + props.sucursal_id + '" ><img src="' + crearventa + '" />&nbsp;Terminar la venta</button></li>';

                                                  break;
                                             case 'facturar':
                                                  if (data.estatus !== "CANCELADA" && data.estatus === "TERMINADA") dropdown += '<li><a class="btn " href="' + props.path + "/facturacion/" + data["id"] + '"><img src="' + facturar + '" />&nbsp;Facturar</a></li>';

                                                  break;
                                             case 'urlExtra':
                                                  dropdown += '<li><a class="btn" href="' + props.pathExtra + data["id"] + '">&nbsp;<img src="' + edit + '"/> Editar</a></li>';
                                                  break;
                                             case 'cancelacionCfdi':
                                                  if (data["estatus_Uuid_Cancelacion"] === null) dropdown += '<li><button class="btn td-cancelar-cfdi" type="button" data-id="' + data["id"] + '">&nbsp;<img src="' + edit + '"/> Cancelar factura</button></li>';

                                                  break;
                                             case 'estatusCfdi':
                                                  if (data["estatus_Uuid_Cancelacion"] !== null && data["estatus_Uuid_Cancelacion"].length > 0) dropdown += '<li><button class="btn td-estatusCfdi" type="button" data-id="' + data["id"] + '">&nbsp;<img src="' + edit + '"/> Estatus factura</button></li>';

                                                  break;
                                             case 'MarcarPagado':
                                                  if (data["estatus_Pago"] === 'Pendiente Pago')
                                                       dropdown += '<li><button class="btn-marcarpagado btn" type="button" data-id="' + data["id"] + '"  data-ruta="' + props.ruta + '/MarcarPagado" data-nombre="' + data['folio'] + '" ><img src="' + coin + '" />&nbsp;Marcar como Pagado</button></li>';

                                                  break;
                                             default: break;
                                        }
                                   }

                                   dropdown += '</ul></div></div>';
                                   return dropdown;
                              }
                         });
                         break;
                    case "check":
                         ArrayData.push({
                              data: null,
                              "render": function (data, type, row, meta) {
                                   return '<input type="checkbox" class="check-select check-select-' + data[i[1]] + '" data-id="' + data[i[1]] + '" />';
                              }
                         });
                         break;
                    case "id":
                         ArrayData.push({
                              data: null,
                              "render": function (data, type, row, meta) {
                                   return ' <label class="classID" data-id="' + data[i[1]] + '">' + data[i[1]] + '</label>';
                              }
                         });
                         break;
                    case "bool":
                         ArrayData.push({
                              "class": "text-center td-button",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   if (data[i[1]] === 'A' || data[i[1]] === 'S' || data[i[1]] === '1' || data[i[1]] === true) return "<input type='checkbox' onclick='return false;' checked/>";
                                   else return "<input type='checkbox' onclick='return false;'/>";
                              }
                         });
                         break;
                    case "conexion":
                         ArrayData.push({
                              "class": "text-center",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   if (data["matriz"] === true) return "<label style='color: blue'>Local</label>";

                                   if (data[i[1]] === '1') return "<label style='color: blue'>Exitosa</label>";

                                   if (data[i[1]] === '0') return "<label style='color: red'>Incorrecta</label>";

                                   if (data[i[1]] === '-1') return "<label style='color: red'>Pendiente de autorización</label>";
                              }
                         });
                         break;
                    case "moneda":
                         ArrayData.push({
                              "class": "text-right",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return "<p>" + currency(data[i[1]]) + "</p>";
                              }
                         });
                         break;
                    case "fecha":
                         ArrayData.push({
                              "class": "text-center fecha-table",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return "<p>" + data[i[1]]?.substring(0, 10) + "</p>";
                              }
                         });
                         break;
                    case "url":
                         ArrayData.push({
                              "class": "td-url",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === null || data[i[1]].length === 0) return "";

                                   return "<a href='" + data[i[1]] + "' target='_blank' rel='noopener noreferrer'>" + data[i[1]]?.substring(0, 30) + "</a>";
                              }
                         });
                         break;
                    case "tipo_documento":
                         ArrayData.push({
                              "class": "text-center",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] === "F") return "Factura";

                                   if (data[i[1]] === "C") return "Cotización";

                                   if (data[i[1]] === "V") return "Venta";
                                   return "";
                              }
                         });
                         break;
                    case "object":
                         ArrayData.push({
                              "class": "text-center",
                              data: null,
                              "render": function (data, type, row, meta) {
                                   if (data[i[1]] !== null) return data[i[1]][i[2]];
                                   else return "";
                              }
                         });
                         break;
                    case "vacio":
                         break;
                    default:
                         ArrayData.push({ "data": i[1] })
                         break;
               }
          });
          //new $.fn.dataTable.Editor
          tableRefInstance.current = $(tableRef.current).DataTable({
               //stateSave: true,
               responsive: true,
               proccessing: true,
               processing: true,
               serverSide: true,
               scrollX: true,
               ajax: {
                    url: baseUrl + props.url,
                    type: 'POST',
                    headers: { 'Authorization': 'Bearer ' + getToken() },
               },
               /* columnDefs: [ {
                    orderable: false,
                    className: 'select-checkbox',
                    targets:   0
               } ],
               select: {
                    style:    'os',
                    selector: 'td:first-child'
               },*/
               order: [[1, 'asc']],
               language:
               {
                    processing: "Procesando...",
                    lengthMenu: "Mostrar _MENU_ registros",
                    zeroRecords: "No se encontraron resultados",
                    emptyTable: "Ningún dato disponible en esta tabla",
                    info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
                    infoFiltered: "(filtrado de un total de _TOTAL_ registros)",
                    search: "Buscar:",
                    infoThousands: ",",
                    loadingRecords: "Cargando...",
                    paginate: {
                         first: "Primero",
                         last: "Último",
                         next: "Siguiente",
                         previous: "Anterior"
                    },
                    aria: {
                         sortAscending: ": Activar para ordenar la columna de manera ascendente",
                         sortDescending: ": Activar para ordenar la columna de manera descendente"
                    },
                    autoFill: {
                         "cancel": "Cancelar",
                         "fill": "Rellene todas las celdas con <i>%d</i>",
                         "fillHorizontal": "Rellenar celdas horizontalmente",
                         "fillVertical": "Rellenar celdas verticalmentemente"
                    },
                    decimal: ",",
                    searchBuilder: {
                         add: "Añadir condición",
                         button: {
                              "0": "Constructor de búsqueda",
                              "_": "Constructor de búsqueda (%d)"
                         },
                         clearAll: "Borrar todo",
                         condition: "Condición",
                         conditions: {
                              "date": {
                                   "after": "Despues",
                                   "before": "Antes",
                                   "between": "Entre",
                                   "empty": "Vacío",
                                   "equals": "Igual a",
                                   "not": "No",
                                   "notBetween": "No entre",
                                   "notEmpty": "No Vacio"
                              },
                              "moment": {
                                   "after": "Despues",
                                   "before": "Antes",
                                   "between": "Entre",
                                   "empty": "Vacío",
                                   "equals": "Igual a",
                                   "not": "No",
                                   "notBetween": "No entre",
                                   "notEmpty": "No vacio"
                              },
                              "number": {
                                   "between": "Entre",
                                   "empty": "Vacio",
                                   "equals": "Igual a",
                                   "gt": "Mayor a",
                                   "gte": "Mayor o igual a",
                                   "lt": "Menor que",
                                   "lte": "Menor o igual que",
                                   "not": "No",
                                   "notBetween": "No entre",
                                   "notEmpty": "No vacío"
                              },
                              "string": {
                                   "contains": "Contiene",
                                   "empty": "Vacío",
                                   "endsWith": "Termina en",
                                   "equals": "Igual a",
                                   "not": "No",
                                   "notEmpty": "No Vacio",
                                   "startsWith": "Empieza con"
                              }
                         },
                         data: "Data",
                         deleteTitle: "Eliminar regla de filtrado",
                         leftTitle: "Criterios anulados",
                         logicAnd: "Y",
                         logicOr: "O",
                         rightTitle: "Criterios de sangría",
                         title: {
                              "0": "Constructor de búsqueda",
                              "_": "Constructor de búsqueda (%d)"
                         },
                         "value": "Valor"
                    },
                    searchPanes: {
                         "clearMessage": "Borrar todo",
                         "collapse": {
                              "0": "Paneles de búsqueda",
                              "_": "Paneles de búsqueda (%d)"
                         },
                         "count": "{total}",
                         "countFiltered": "{shown} ({total})",
                         "emptyPanes": "Sin paneles de búsqueda",
                         "loadMessage": "Cargando paneles de búsqueda",
                         "title": "Filtros Activos - %d"
                    },
                    select: {
                         "1": "%d fila seleccionada",
                         "_": "%d filas seleccionadas",

                    },
                    "thousands": "."
               },
               columns: ArrayData,
               drawCallback: function () {
                    this.api().state.clear();
                    $(".varianteClass").each(function () {
                         $(this).parent().removeClass('details-control');
                    });
               }
          })
          return function () {
               tableRefInstance.current?.destroy()
          }
     }, [props.opciones, props.path, props.pathExtra, props.rows, props.ruta, props.sucursal_id, props.url])

     React.useEffect(() => {
          rellenarTable();
     }, [rellenarTable]);

     function format(d) {
          if (d.length > 0) {
               var variantes = "";
               d.forEach((art) => {
                    variantes += '<tr>' +
                         '  <td>' + art.sku + '</td>' +
                         '  <td>' + art.nombre + '</td>' +
                         '  <td>' + art.clave_Prod_Serv + '</td>' +
                         '  <td>' + art.no_Identificacion + '</td>' +
                         '  <td>' + art.clave_Unidad + '</td>' +
                         '</tr>'
               });
               return ('<table class="table" style="min-width: 60%;">' +
                    '<tr>' +
                    '<th>SKU</th>' +
                    '<th>Nombre</th>' +
                    '<th>Clave SAT</th>' +
                    '<th>No. Identificación</th>' +
                    '<th>Clave Unidad</th>' +
                    '</tr>' +
                    '<tbody>' +
                    variantes
                    +
                    '</tbody>' +
                    '</table>'
               );
          }
     }

     useEffect(() => {
          rellenarTable();
          //$('#mySelect').selectpicker();
          $("table").on("click", ".td-estatusCfdi", function (_event) {
               var id = $(this).attr("data-id");
               fetchConToken(`facturacion/estatusFactura?cfdi_id=${id}`).then((response) => {
                    if (response.hasOwnProperty('status') && response.status === 400) {
                         Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                         return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                         Swal.fire('Error', response.mensajes[0], 'error');
                         return false;
                    }

                    Swal.fire('Exito', 'Solicitud actualizada', 'success');
                    var table = $('#table-js').DataTable();
                    table.ajax.reload();
               })
          });
          $("table").on("click", ".btn-descargar", function (_event) {
               var id = $(this).attr("data-id");
               var ruta = $(this).attr("data-ruta");
               var nombre = $(this).attr("data-nombre");
               descargarFactura(id, ruta, nombre);
          });
          $("table").on("click", ".btn-marcarpagado", function (_event) {
               var id = $(this).attr("data-id");
               var ruta = $(this).attr("data-ruta");
               var nombre = $(this).attr("data-nombre");
               Swal.fire({
                    icon: 'warning',
                    html: 'Esta seguro de registrar como pagada la factura: ' + nombre + '<br/><input id="datetimepicker" type="date" class="form-control" autofocus>',
                    showCancelButton: true,
                    confirmButtonText: "Registrar Pago",
                    cancelButtonText: 'Cancelar'
               }).then((result) => {
                    if (result.isConfirmed) {
                         if ($('#datetimepicker').val() !== undefined && $('#datetimepicker').val().length > 0) {
                              fetchConToken(ruta + "?fac_id=" + id + "&fecha=" + $('#datetimepicker').val(), null, 'POST').then(function (response) {
                                   if (response.hasOwnProperty('status') && response.status === 400) {
                                        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                                        tableRefInstance.current?.ajax.reload();
                                        return;
                                   } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                                        Swal.fire('Error', response.mensajes[0], 'error');
                                        tableRefInstance.current?.ajax.reload();
                                        return;
                                   }

                                   tableRefInstance.current?.ajax.reload();
                                   Swal.fire('Exitoso', 'Orden Actualizada', 'success');
                              });
                         }
                         else Swal.fire('Info', 'Seleccione una fecha de pago', 'info');
                    }
               })
          });
          $("table").on("click", ".td-actualizarventa", function (_event) {
               var table = $('#table-js').DataTable();
               var orden = $(this).attr("data-orden");
               fetchConToken(
                    `Ventas/DescargarVentaById?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}&id=${orden}`,
                    null,
                    'POST'
               ).then(function (response) {
                    if (response.hasOwnProperty('status') && response.status === 400) {
                         Object.entries(response.errors).forEach(([, value]) => {
                              Swal.fire('Error', value[0], 'error');
                         });
                         table.ajax.reload();
                         return;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                         Swal.fire('Error', response.mensajes[0], 'error');
                         table.ajax.reload();
                         return;
                    }

                    table.ajax.reload();
                    Swal.fire('Exitoso', 'Orden Actualizada', 'success');
               });

          });
          $("table").on("click", ".td-crearventa", function (event) {
               var ruta = $(this).attr("data-ruta");
               var evento = $(this).attr("data-evento");
               var table = $('#table-js').DataTable();
               Swal.fire({
                    text: 'Esta seguro de ' + evento,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: evento,
                    cancelButtonText: 'Cancelar'
               }).then((result) => {
                    if (result.isConfirmed) {
                         fetchConToken(ruta, null, 'POST').then((response) => {
                              if (response.hasOwnProperty('status') && response.status === 400) {
                                   Object.entries(response.errors).forEach(([, value]) => {
                                        Swal.fire('Error', value[0], 'error');
                                        table.ajax.reload();
                                   });
                                   return false;
                              } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                                   Swal.fire('Error', response.mensajes[0], 'error');
                                   table.ajax.reload();
                                   return false;
                              }

                              table.ajax.reload();
                              window.location.reload()
                         })
                    }
               })
          });
          $("table").on("click", ".td-cancelar-cfdi", function (event) {
               var id = $(this).attr("data-id");
               Swal.fire({
                    text: 'Esta seguro de cancelar la factura',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Cancelar factura",
                    cancelButtonText: 'Cancelar',
                    input: 'select',
                    inputOptions: {
                         '01': 'Comprobante emitido con errores con relación',
                         '02': 'Comprobante emitido con errores sin relación',
                         '03': 'No se llevó a cabo la operación',
                         '04': 'Operación nominativa relacionada en la factura global'
                    }
               }).then((result) => {
                    if (result.isConfirmed) {
                         fetchConToken(`facturacion/CancelarCfdi?cfdi_id=${id}&motivo=${result.value}`,).then((response) => {
                              if (response.hasOwnProperty('status') && response.status === 400) {
                                   Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                                   return false;
                              } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                                   Swal.fire('Error', response.mensajes[0], 'error');
                                   return false;
                              }

                              Swal.fire('Exito', 'Solicitud enviada', 'success');
                              var table = $('#table-js').DataTable();
                              table.ajax.reload();
                         })
                    }
               })
          });
          var table2 = $('#table-js').DataTable();
          $('#table-js tbody').on('click', 'tr td.details-control', function () {
               var tr = $(this).closest('tr');
               var articulo_id = $(this.firstChild).attr('data-id');
               var row = table2.row(tr);
               var idx = detailRows.indexOf(tr.attr('id'));
               if (row.child.isShown()) {
                    tr.removeClass('details');
                    row.child.hide();
                    // Remove from the 'open' array
                    detailRows.splice(idx, 1);
               } else {
                    tr.addClass('details');
                    fetchConToken(`articulos/Variantes?articulo_id=${articulo_id}`).then((imp) => {
                         console.log(imp)
                         row.child(format(imp)).show();
                    });

                    // Add to the 'open' array
                    if (idx === -1) detailRows.push(tr.attr('id'));
               }
          });
          /*var editor = new $.fn.dataTable.Editor( {
               table: "#table-js"
           } );
          $('#table-js').on( 'click', 'tbody td:not(:first-child)', function (e) {
               editor.inline( this );
           } );*/

          // On each draw, loop over the `detailRows` array and show any child rows
          /*
          table2.on('draw', function () {
              detailRows.forEach(function(id, i) {
                  $('#' + id + ' td.details-control').trigger('click');
              });
          });*/
     }, [rellenarTable])

     return <div className="datetable-scroll">
          <div>
               <table id="table-js" className="ui celled table" width="100%" ref={tableRef}>
                    <thead>
                         <tr>
                              {props.columns.filter(item => item !== 'vacio').map((item) => { return <th key={item} >{item}</th> })}
                         </tr>
                    </thead>
               </table>
          </div>
     </div>
}

export default Table;